import yn from 'yn';
import mockPlans from '../../__mocks__/plans/currency-response.json';
import stripePlansMock from '../../__mocks__/stripe/plans.json';
import { ffhClient } from '@lib/api/ffh-client';

const fetchPlans = async (keys?: string[]): Promise<any> => {
  if (yn(process.env.NEXT_PUBLIC_MOCK_API_CALLS)) {
    return mockPlans;
  }

  // In mock mode the backend is usually unreachable, so short-circuit with a
  // captured live response. Matches the MSW pattern used in tests.
  if (yn(process.env.NEXT_PUBLIC_USE_MOCK_FFH_BACKEND)) {
    return stripePlansMock;
  }

  if (!keys || keys.length === 0) {
    return { error: 'At least one plan lookup key is required' };
  }

  const { data, error, response } = await ffhClient().GET('/billing/plans', {
    params: { query: { keys: keys.join(',') } }
  });

  if (error || !data) {
    return { error: response?.status ?? 'Failed to fetch plans' };
  }

  return data;
};

export default fetchPlans;
